<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <label>Please make sure all json keys in the text area are unique</label>
                        <button type="button" class="close" @click="$emit('close')" data-dismiss="modal"
                                aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form v-on:submit.prevent="sendCommand" novalidate>
                            <textarea id="textarea1" class="form-control"
                                      v-model="packetValue"
                                      :rows="10">
                            </textarea>
                            <button class="btn btn-primary mt-2 float-right">Send Command</button>
                        </form>
                        <div class="form-row">
                            <div class="col-md-9 mb-3">
                                <transition name="fade">
                                    <div class="alert alert-success" v-if="response.isSuccess">The command has been send
                                        success fully
                                    </div>
                                </transition>
                            </div>
                        </div>
                        <pre class="mt-3">{{ updatedJson }}</pre>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
  import Vue from 'vue'
  import ConnectionService from '../../app-model/model'

  const connectionService = new ConnectionService()

  export default {
    props: {
      dataToPassToModal: Object,
      confirm: Object,
    },
    data () {
      return {
        packet:
          {
            packet: {
              'src_id': 0,
              'dst_id': parseInt(`${this.dataToPassToModal.deviceId}`),
              'freq': 0,
              'ip_addr': `${this.dataToPassToModal.ip_address}`,
              'msg_seq_num': 0,
              'ack_req': 0,
              'msg_id': 7
            }
          },
        response: {
          isSuccess: false
        }
      }
    },
    computed: {
      packetValue: {
        get () {
          let newArray = new Array()
          $.map(this.packet, (value1, index1) => {
            newArray = $.map(value1, (index, value) => {
              return `${value}:${index}`
            })
          })

          return newArray.join('\n')
        },
        set (newValue) {
          let newPacket = {}
          newValue = newValue.split('\n')
          let key, value

          for (let i = 0; i < newValue.length; i++) {
            key = `${newValue[i].substring(0, newValue[i].indexOf(':'))}`
            value = newValue[i].substring(newValue[i].indexOf(':') + 1)

            var intLast = parseInt(value)

            if (intLast.toString() === value) {
              newPacket[key] = intLast
            }
            else {
              newPacket[key] = value
            }
          }

          Vue.set(this.packet, 'packet', newPacket)
        }
      },

      updatedJson () {
        return JSON.stringify(this.packet)
      }
    },

    methods: {
      sendCommand: function () {
        this.$store.dispatch('apiResult', {
          method: 'POST',
          path: `api/devices-commands/${this.dataToPassToModal.deviceId}/manual-command`,
          data: this.packet,
          path_template: '/api/devices-commands/{device_id}/manual-command'
        }).then(response => {
          switch (response.status) {
            case 200:
              connectionService['responseInTime']({responseObject: this.response, value: 'isSuccess', status: true})
              break
          }
        })
      }
    }
  }
</script>
<style>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 800px;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
        width: auto;
    }

    .modal-default-button {
        float: right;
    }

    /*
     * The following styles are auto-applied to elements with
     * transition="modal" when their visibility is toggled
     * by Vue.js.
     *
     * You can easily play with the modal transition by editing
     * these styles.
     */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>
